import { CurrencyMetadata } from '../types';

export const GLOBAL_CURRENCIES_LIST: CurrencyMetadata[] = [
  // -------------------------------------------------------------
  // G10 & MAJOR GLOBAL CURRENCIES
  // -------------------------------------------------------------
  {
    code: 'USD',
    numericCode: '840',
    name: 'United States Dollar',
    localizedName: 'Dollar américain',
    symbol: '$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Federal Reserve System (Fed)',
    countries: ['United States', 'Ecuador', 'El Salvador', 'Panama', 'Puerto Rico'],
    flagEmoji: '🇺🇸',
    isMajor: true,
    isPopular: true,
    region: 'North America',
    aliases: ['dollar', 'us dollar', 'buck', 'greenback', 'usd'],
    historicalFromYear: 1970,
  },
  {
    code: 'EUR',
    numericCode: '978',
    name: 'Euro',
    localizedName: 'Euro',
    symbol: '€',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'European Central Bank (ECB)',
    countries: ['Eurozone (20 countries: Germany, France, Italy, Spain, Netherlands, etc.)', 'Kosovo', 'Montenegro'],
    flagEmoji: '🇪🇺',
    isMajor: true,
    isPopular: true,
    region: 'Europe',
    aliases: ['euro', 'euros', 'eur'],
    historicalFromYear: 1999,
  },
  {
    code: 'GBP',
    numericCode: '826',
    name: 'British Pound Sterling',
    localizedName: 'Livre sterling',
    symbol: '£',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of England (BoE)',
    countries: ['United Kingdom', 'Isle of Man', 'Jersey', 'Guernsey'],
    flagEmoji: '🇬🇧',
    isMajor: true,
    isPopular: true,
    region: 'Europe',
    aliases: ['pound', 'sterling', 'quid', 'british pound', 'gbp'],
    historicalFromYear: 1970,
  },
  {
    code: 'JPY',
    numericCode: '392',
    name: 'Japanese Yen',
    localizedName: 'Yen japonais',
    symbol: '¥',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Japan (BoJ)',
    countries: ['Japan'],
    flagEmoji: '🇯🇵',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['yen', 'japanese yen', 'jpy'],
    historicalFromYear: 1970,
  },
  {
    code: 'CAD',
    numericCode: '124',
    name: 'Canadian Dollar',
    localizedName: 'Dollar canadien',
    symbol: 'CA$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Canada (BoC)',
    countries: ['Canada'],
    flagEmoji: '🇨🇦',
    isMajor: true,
    isPopular: true,
    region: 'North America',
    aliases: ['canadian dollar', 'loonie', 'cad'],
    historicalFromYear: 1970,
  },
  {
    code: 'CHF',
    numericCode: '756',
    name: 'Swiss Franc',
    localizedName: 'Franc suisse',
    symbol: 'CHF',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Swiss National Bank (SNB)',
    countries: ['Switzerland', 'Liechtenstein'],
    flagEmoji: '🇨🇭',
    isMajor: true,
    isPopular: true,
    region: 'Europe',
    aliases: ['swiss franc', 'franc', 'chf'],
    historicalFromYear: 1970,
  },
  {
    code: 'AUD',
    numericCode: '036',
    name: 'Australian Dollar',
    localizedName: 'Dollar australien',
    symbol: 'A$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Reserve Bank of Australia (RBA)',
    countries: ['Australia', 'Kiribati', 'Nauru', 'Tuvalu'],
    flagEmoji: '🇦🇺',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['australian dollar', 'aussie', 'aud'],
    historicalFromYear: 1970,
  },
  {
    code: 'NZD',
    numericCode: '554',
    name: 'New Zealand Dollar',
    localizedName: 'Dollar néo-zélandais',
    symbol: 'NZ$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Reserve Bank of New Zealand (RBNZ)',
    countries: ['New Zealand', 'Cook Islands', 'Niue', 'Pitcairn Islands'],
    flagEmoji: '🇳🇿',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['new zealand dollar', 'kiwi', 'nzd'],
    historicalFromYear: 1970,
  },
  {
    code: 'CNY',
    numericCode: '156',
    name: 'Chinese Yuan Renminbi',
    localizedName: 'Yuan renminbi chinois',
    symbol: '¥',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: "People's Bank of China (PBOC)",
    countries: ['China'],
    flagEmoji: '🇨🇳',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['yuan', 'renminbi', 'rmb', 'cny'],
    historicalFromYear: 1980,
  },
  {
    code: 'INR',
    numericCode: '356',
    name: 'Indian Rupee',
    localizedName: 'Roupie indienne',
    symbol: '₹',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Reserve Bank of India (RBI)',
    countries: ['India', 'Bhutan'],
    flagEmoji: '🇮🇳',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['rupee', 'indian rupee', 'inr'],
    historicalFromYear: 1970,
  },
  {
    code: 'SGD',
    numericCode: '702',
    name: 'Singapore Dollar',
    localizedName: 'Dollar de Singapour',
    symbol: 'S$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Monetary Authority of Singapore (MAS)',
    countries: ['Singapore', 'Brunei'],
    flagEmoji: '🇸🇬',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['singapore dollar', 'sgd'],
    historicalFromYear: 1970,
  },
  {
    code: 'HKD',
    numericCode: '344',
    name: 'Hong Kong Dollar',
    localizedName: 'Dollar de Hong Kong',
    symbol: 'HK$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Hong Kong Monetary Authority (HKMA)',
    countries: ['Hong Kong'],
    flagEmoji: '🇭🇰',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 7.80,
      bandVariancePct: 0.65, // 7.75 - 7.85 Linked Exchange Rate System
      monetaryTreaty: 'HKMA Currency Board System',
      effectiveSince: '1983-10-17',
    },
    aliases: ['hong kong dollar', 'hkd'],
  },
  {
    code: 'SEK',
    numericCode: '752',
    name: 'Swedish Krona',
    localizedName: 'Couronne suédoise',
    symbol: 'kr',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Sveriges Riksbank',
    countries: ['Sweden'],
    flagEmoji: '🇸🇪',
    isMajor: true,
    isPopular: false,
    region: 'Europe',
    aliases: ['krona', 'swedish krona', 'sek'],
  },
  {
    code: 'NOK',
    numericCode: '578',
    name: 'Norwegian Krone',
    localizedName: 'Couronne norvégienne',
    symbol: 'kr',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Norges Bank',
    countries: ['Norway', 'Svalbard'],
    flagEmoji: '🇳🇴',
    isMajor: true,
    isPopular: false,
    region: 'Europe',
    aliases: ['krone', 'norwegian krone', 'nok'],
  },
  {
    code: 'DKK',
    numericCode: '208',
    name: 'Danish Krone',
    localizedName: 'Couronne danoise',
    symbol: 'kr',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Danmarks Nationalbank',
    countries: ['Denmark', 'Greenland', 'Faroe Islands'],
    flagEmoji: '🇩🇰',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    pegInfo: {
      peggedToCurrency: 'EUR',
      fixedRate: 7.46038,
      bandVariancePct: 2.25, // ERM II mechanism
      monetaryTreaty: 'European Exchange Rate Mechanism II',
      effectiveSince: '1999-01-01',
    },
    aliases: ['danish krone', 'dkk'],
  },

  // -------------------------------------------------------------
  // MIDDLE EAST & GULF COOPERATION COUNCIL (GCC)
  // -------------------------------------------------------------
  {
    code: 'AED',
    numericCode: '784',
    name: 'United Arab Emirates Dirham',
    localizedName: 'Dirham des Émirats arabes unis',
    symbol: 'د.إ',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Central Bank of the UAE (CBUAE)',
    countries: ['United Arab Emirates'],
    flagEmoji: '🇦🇪',
    isMajor: true,
    isPopular: true,
    region: 'Middle East',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 3.6725,
      monetaryTreaty: 'UAE Sovereign Dollar Peg',
      effectiveSince: '1997-11-01',
    },
    aliases: ['dirham', 'emirati dirham', 'aed'],
  },
  {
    code: 'SAR',
    numericCode: '682',
    name: 'Saudi Riyal',
    localizedName: 'Riyal saoudien',
    symbol: '﷼',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Saudi Central Bank (SAMA)',
    countries: ['Saudi Arabia'],
    flagEmoji: '🇸🇦',
    isMajor: true,
    isPopular: true,
    region: 'Middle East',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 3.75,
      monetaryTreaty: 'SAMA Sovereign Dollar Peg',
      effectiveSince: '1986-06-01',
    },
    aliases: ['saudi riyal', 'riyal', 'sar'],
  },
  {
    code: 'QAR',
    numericCode: '634',
    name: 'Qatari Riyal',
    localizedName: 'Riyal qatari',
    symbol: 'QR',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Qatar Central Bank (QCB)',
    countries: ['Qatar'],
    flagEmoji: '🇶🇦',
    isMajor: false,
    isPopular: true,
    region: 'Middle East',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 3.64,
      monetaryTreaty: 'QCB Sovereign Dollar Peg',
      effectiveSince: '2001-07-09',
    },
    aliases: ['qatari riyal', 'qar'],
  },
  {
    code: 'KWD',
    numericCode: '414',
    name: 'Kuwaiti Dinar',
    localizedName: 'Dinar koweïtien',
    symbol: 'KD',
    minorUnits: 3,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Central Bank of Kuwait (CBK)',
    countries: ['Kuwait'],
    flagEmoji: '🇰🇼',
    isMajor: true,
    isPopular: true,
    region: 'Middle East',
    aliases: ['kuwaiti dinar', 'kwd'],
  },
  {
    code: 'BHD',
    numericCode: '048',
    name: 'Bahraini Dinar',
    localizedName: 'Dinar bahreïni',
    symbol: 'BD',
    minorUnits: 3,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Central Bank of Bahrain (CBB)',
    countries: ['Bahrain'],
    flagEmoji: '🇧🇭',
    isMajor: false,
    isPopular: false,
    region: 'Middle East',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 0.376,
      effectiveSince: '2001-01-01',
    },
    aliases: ['bahraini dinar', 'bhd'],
  },
  {
    code: 'OMR',
    numericCode: '512',
    name: 'Omani Rial',
    localizedName: 'Rial omanais',
    symbol: 'RO',
    minorUnits: 3,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Central Bank of Oman (CBO)',
    countries: ['Oman'],
    flagEmoji: '🇴🇲',
    isMajor: false,
    isPopular: false,
    region: 'Middle East',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 0.3845,
      effectiveSince: '1986-01-01',
    },
    aliases: ['omani rial', 'omr'],
  },
  {
    code: 'ILS',
    numericCode: '376',
    name: 'Israeli New Shekel',
    localizedName: 'Nouveau shekel israélien',
    symbol: '₪',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Israel',
    countries: ['Israel', 'Palestinian territories'],
    flagEmoji: '🇮🇱',
    isMajor: false,
    isPopular: false,
    region: 'Middle East',
    aliases: ['shekel', 'ils'],
  },

  // -------------------------------------------------------------
  // LATIN AMERICA & CARIBBEAN
  // -------------------------------------------------------------
  {
    code: 'BRL',
    numericCode: '986',
    name: 'Brazilian Real',
    localizedName: 'Real brésilien',
    symbol: 'R$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Brazil (BCB)',
    countries: ['Brazil'],
    flagEmoji: '🇧🇷',
    isMajor: true,
    isPopular: true,
    region: 'Latin America',
    aliases: ['brazilian real', 'real', 'brl'],
  },
  {
    code: 'MXN',
    numericCode: '484',
    name: 'Mexican Peso',
    localizedName: 'Peso mexicain',
    symbol: 'Mex$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Mexico (Banxico)',
    countries: ['Mexico'],
    flagEmoji: '🇲🇽',
    isMajor: true,
    isPopular: true,
    region: 'Latin America',
    aliases: ['mexican peso', 'peso', 'mxn'],
  },
  {
    code: 'ARS',
    numericCode: '032',
    name: 'Argentine Peso',
    localizedName: 'Peso argentin',
    symbol: '$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Central Bank of Argentina (BCRA)',
    countries: ['Argentina'],
    flagEmoji: '🇦🇷',
    isMajor: false,
    isPopular: true,
    region: 'Latin America',
    aliases: ['argentine peso', 'ars'],
  },
  {
    code: 'CLP',
    numericCode: '152',
    name: 'Chilean Peso',
    localizedName: 'Peso chilien',
    symbol: 'CLP$',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Chile',
    countries: ['Chile'],
    flagEmoji: '🇨🇱',
    isMajor: false,
    isPopular: false,
    region: 'Latin America',
    aliases: ['chilean peso', 'clp'],
  },
  {
    code: 'COP',
    numericCode: '170',
    name: 'Colombian Peso',
    localizedName: 'Peso colombien',
    symbol: 'COL$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of the Republic (Colombia)',
    countries: ['Colombia'],
    flagEmoji: '🇨🇴',
    isMajor: false,
    isPopular: true,
    region: 'Latin America',
    aliases: ['colombian peso', 'cop'],
  },
  {
    code: 'PEN',
    numericCode: '604',
    name: 'Peruvian Sol',
    localizedName: 'Sol péruvien',
    symbol: 'S/',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Reserve Bank of Peru',
    countries: ['Peru'],
    flagEmoji: '🇵🇪',
    isMajor: false,
    isPopular: false,
    region: 'Latin America',
    aliases: ['peruvian sol', 'sol', 'pen'],
  },
  {
    code: 'PAB',
    numericCode: '590',
    name: 'Panamanian Balboa',
    localizedName: 'Balboa panaméen',
    symbol: 'B/.',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'National Bank of Panama',
    countries: ['Panama'],
    flagEmoji: '🇵🇦',
    isMajor: false,
    isPopular: false,
    region: 'Latin America',
    pegInfo: {
      peggedToCurrency: 'USD',
      fixedRate: 1.0,
      monetaryTreaty: 'Panama Monetary Agreement 1904',
      effectiveSince: '1904-06-20',
    },
    aliases: ['balboa', 'pab'],
  },

  // -------------------------------------------------------------
  // AFRICA & CEMAC / WAEMU
  // -------------------------------------------------------------
  {
    code: 'ZAR',
    numericCode: '710',
    name: 'South African Rand',
    localizedName: 'Rand sud-africain',
    symbol: 'R',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'South African Reserve Bank (SARB)',
    countries: ['South Africa', 'Namibia', 'Lesotho', 'Eswatini (Common Monetary Area)'],
    flagEmoji: '🇿🇦',
    isMajor: true,
    isPopular: true,
    region: 'Africa',
    aliases: ['rand', 'south african rand', 'zar'],
  },
  {
    code: 'NGN',
    numericCode: '566',
    name: 'Nigerian Naira',
    localizedName: 'Naira nigérian',
    symbol: '₦',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Central Bank of Nigeria (CBN)',
    countries: ['Nigeria'],
    flagEmoji: '🇳🇬',
    isMajor: true,
    isPopular: true,
    region: 'Africa',
    aliases: ['naira', 'nigerian naira', 'ngn'],
  },
  {
    code: 'KES',
    numericCode: '404',
    name: 'Kenyan Shilling',
    localizedName: 'Shilling kényan',
    symbol: 'KSh',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Kenya (CBK)',
    countries: ['Kenya'],
    flagEmoji: '🇰🇪',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    aliases: ['kenyan shilling', 'kes'],
  },
  {
    code: 'GHS',
    numericCode: '936',
    name: 'Ghanaian Cedi',
    localizedName: 'Cedi ghanéen',
    symbol: 'GH₵',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Ghana',
    countries: ['Ghana'],
    flagEmoji: '🇬🇭',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    aliases: ['cedi', 'ghs'],
  },
  {
    code: 'EGP',
    numericCode: '818',
    name: 'Egyptian Pound',
    localizedName: 'Livre égyptienne',
    symbol: 'E£',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Central Bank of Egypt (CBE)',
    countries: ['Egypt', 'Gaza Strip'],
    flagEmoji: '🇪🇬',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    aliases: ['egyptian pound', 'egp'],
  },
  {
    code: 'MAD',
    numericCode: '504',
    name: 'Moroccan Dirham',
    localizedName: 'Dirham marocain',
    symbol: 'DH',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Bank Al-Maghrib',
    countries: ['Morocco', 'Western Sahara'],
    flagEmoji: '🇲🇦',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    aliases: ['moroccan dirham', 'mad'],
  },
  {
    code: 'XAF',
    numericCode: '950',
    name: 'Central African CFA Franc',
    localizedName: 'Franc CFA d’Afrique centrale',
    symbol: 'FCFA',
    minorUnits: 0,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Bank of Central African States (BEAC)',
    countries: ['Cameroon', 'Central African Republic', 'Chad', 'Republic of the Congo', 'Equatorial Guinea', 'Gabon'],
    flagEmoji: '🇨🇲',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    pegInfo: {
      peggedToCurrency: 'EUR',
      fixedRate: 655.957, // 1 EUR = 655.957 XAF
      monetaryTreaty: 'CEMAC Monetary Cooperation Agreement with French Treasury',
      effectiveSince: '1999-01-01',
    },
    aliases: ['cfa franc', 'franc cfa', 'beac', 'xaf'],
  },
  {
    code: 'XOF',
    numericCode: '952',
    name: 'West African CFA Franc',
    localizedName: 'Franc CFA d’Afrique de l’Ouest',
    symbol: 'CFA',
    minorUnits: 0,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Central Bank of West African States (BCEAO)',
    countries: ['Benin', 'Burkina Faso', 'Côte d’Ivoire', 'Guinea-Bissau', 'Mali', 'Niger', 'Senegal', 'Togo'],
    flagEmoji: '🇨🇮',
    isMajor: false,
    isPopular: true,
    region: 'Africa',
    pegInfo: {
      peggedToCurrency: 'EUR',
      fixedRate: 655.957, // 1 EUR = 655.957 XOF
      monetaryTreaty: 'UEMOA Monetary Agreement with French Treasury',
      effectiveSince: '1999-01-01',
    },
    aliases: ['west african cfa', 'bceao', 'xof'],
  },
  {
    code: 'DZD',
    numericCode: '012',
    name: 'Algerian Dinar',
    localizedName: 'Dinar algérien',
    symbol: 'DA',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Bank of Algeria',
    countries: ['Algeria'],
    flagEmoji: '🇩🇿',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['algerian dinar', 'dzd'],
  },
  {
    code: 'TND',
    numericCode: '788',
    name: 'Tunisian Dinar',
    localizedName: 'Dinar tunisien',
    symbol: 'DT',
    minorUnits: 3,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Tunisia',
    countries: ['Tunisia'],
    flagEmoji: '🇹🇳',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['tunisian dinar', 'tnd'],
  },
  {
    code: 'UGX',
    numericCode: '800',
    name: 'Ugandan Shilling',
    localizedName: 'Shilling ougandais',
    symbol: 'USh',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Uganda',
    countries: ['Uganda'],
    flagEmoji: '🇺🇬',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['ugandan shilling', 'ugx'],
  },
  {
    code: 'TZS',
    numericCode: '834',
    name: 'Tanzanian Shilling',
    localizedName: 'Shilling tanzanien',
    symbol: 'TSh',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Tanzania',
    countries: ['Tanzania'],
    flagEmoji: '🇹🇿',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['tanzanian shilling', 'tzs'],
  },
  {
    code: 'RWF',
    numericCode: '646',
    name: 'Rwandan Franc',
    localizedName: 'Franc rwandais',
    symbol: 'FRw',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'National Bank of Rwanda',
    countries: ['Rwanda'],
    flagEmoji: '🇷🇼',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['rwandan franc', 'rwf'],
  },
  {
    code: 'MUR',
    numericCode: '480',
    name: 'Mauritian Rupee',
    localizedName: 'Roupie mauricienne',
    symbol: '₨',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Mauritius',
    countries: ['Mauritius'],
    flagEmoji: '🇲🇺',
    isMajor: false,
    isPopular: false,
    region: 'Africa',
    aliases: ['mauritian rupee', 'mur'],
  },

  // -------------------------------------------------------------
  // OTHER ASIA-PACIFIC & CENTRAL ASIA
  // -------------------------------------------------------------
  {
    code: 'KRW',
    numericCode: '410',
    name: 'South Korean Won',
    localizedName: 'Won sud-coréen',
    symbol: '₩',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Korea',
    countries: ['South Korea'],
    flagEmoji: '🇰🇷',
    isMajor: true,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['won', 'korean won', 'krw'],
  },
  {
    code: 'TWD',
    numericCode: '901',
    name: 'New Taiwan Dollar',
    localizedName: 'Nouveau dollar de Taïwan',
    symbol: 'NT$',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of the Republic of China (Taiwan)',
    countries: ['Taiwan'],
    flagEmoji: '🇹🇼',
    isMajor: false,
    isPopular: false,
    region: 'Asia-Pacific',
    aliases: ['taiwan dollar', 'twd'],
  },
  {
    code: 'THB',
    numericCode: '764',
    name: 'Thai Baht',
    localizedName: 'Baht thaïlandais',
    symbol: '฿',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank of Thailand',
    countries: ['Thailand'],
    flagEmoji: '🇹🇭',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['baht', 'thai baht', 'thb'],
  },
  {
    code: 'IDR',
    numericCode: '360',
    name: 'Indonesian Rupiah',
    localizedName: 'Rupiah indonésienne',
    symbol: 'Rp',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank Indonesia',
    countries: ['Indonesia'],
    flagEmoji: '🇮🇩',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['rupiah', 'indonesian rupiah', 'idr'],
  },
  {
    code: 'MYR',
    numericCode: '458',
    name: 'Malaysian Ringgit',
    localizedName: 'Ringgit malaisien',
    symbol: 'RM',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bank Negara Malaysia',
    countries: ['Malaysia'],
    flagEmoji: '🇲🇾',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['ringgit', 'myr'],
  },
  {
    code: 'PHP',
    numericCode: '608',
    name: 'Philippine Peso',
    localizedName: 'Peso philippin',
    symbol: '₱',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Bangko Sentral ng Pilipinas',
    countries: ['Philippines'],
    flagEmoji: '🇵🇭',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['philippine peso', 'php'],
  },
  {
    code: 'VND',
    numericCode: '704',
    name: 'Vietnamese Dong',
    localizedName: 'Dong vietnamien',
    symbol: '₫',
    minorUnits: 0,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'State Bank of Vietnam',
    countries: ['Vietnam'],
    flagEmoji: '🇻🇳',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['dong', 'vietnamese dong', 'vnd'],
  },
  {
    code: 'PKR',
    numericCode: '586',
    name: 'Pakistani Rupee',
    localizedName: 'Roupie pakistanaise',
    symbol: '₨',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'State Bank of Pakistan',
    countries: ['Pakistan'],
    flagEmoji: '🇵🇰',
    isMajor: false,
    isPopular: true,
    region: 'Asia-Pacific',
    aliases: ['pakistani rupee', 'pkr'],
  },
  {
    code: 'BDT',
    numericCode: '050',
    name: 'Bangladeshi Taka',
    localizedName: 'Taka bangladais',
    symbol: '৳',
    minorUnits: 2,
    category: 'FIAT',
    status: 'MANAGED',
    monetaryAuthority: 'Bangladesh Bank',
    countries: ['Bangladesh'],
    flagEmoji: '🇧🇩',
    isMajor: false,
    isPopular: false,
    region: 'Asia-Pacific',
    aliases: ['taka', 'bdt'],
  },
  {
    code: 'LKR',
    numericCode: '144',
    name: 'Sri Lankan Rupee',
    localizedName: 'Roupie srilankaise',
    symbol: 'Rs',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Sri Lanka',
    countries: ['Sri Lanka'],
    flagEmoji: '🇱🇰',
    isMajor: false,
    isPopular: false,
    region: 'Asia-Pacific',
    aliases: ['sri lankan rupee', 'lkr'],
  },
  {
    code: 'KZT',
    numericCode: '398',
    name: 'Kazakhstani Tenge',
    localizedName: 'Tenge kazakh',
    symbol: '₸',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'National Bank of Kazakhstan',
    countries: ['Kazakhstan'],
    flagEmoji: '🇰🇿',
    isMajor: false,
    isPopular: false,
    region: 'Asia-Pacific',
    aliases: ['tenge', 'kzt'],
  },
  {
    code: 'TRY',
    numericCode: '949',
    name: 'Turkish Lira',
    localizedName: 'Livre turque',
    symbol: '₺',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of the Republic of Turkey (CBRT)',
    countries: ['Turkey', 'Northern Cyprus'],
    flagEmoji: '🇹🇷',
    isMajor: false,
    isPopular: true,
    region: 'Europe',
    aliases: ['lira', 'turkish lira', 'try'],
  },
  {
    code: 'PLN',
    numericCode: '985',
    name: 'Polish Zloty',
    localizedName: 'Zloty polonais',
    symbol: 'zł',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'National Bank of Poland (NBP)',
    countries: ['Poland'],
    flagEmoji: '🇵🇱',
    isMajor: false,
    isPopular: true,
    region: 'Europe',
    aliases: ['zloty', 'polish zloty', 'pln'],
  },
  {
    code: 'CZK',
    numericCode: '203',
    name: 'Czech Koruna',
    localizedName: 'Couronne tchèque',
    symbol: 'Kč',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Czech National Bank (CNB)',
    countries: ['Czech Republic'],
    flagEmoji: '🇨🇿',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    aliases: ['koruna', 'czech koruna', 'czk'],
  },
  {
    code: 'HUF',
    numericCode: '348',
    name: 'Hungarian Forint',
    localizedName: 'Forint hongrois',
    symbol: 'Ft',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Hungarian National Bank (MNB)',
    countries: ['Hungary'],
    flagEmoji: '🇭🇺',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    aliases: ['forint', 'huf'],
  },
  {
    code: 'RON',
    numericCode: '946',
    name: 'Romanian Leu',
    localizedName: 'Leu roumain',
    symbol: 'lei',
    minorUnits: 2,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'National Bank of Romania (BNR)',
    countries: ['Romania'],
    flagEmoji: '🇷🇴',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    aliases: ['leu', 'romanian leu', 'ron'],
  },
  {
    code: 'BGN',
    numericCode: '975',
    name: 'Bulgarian Lev',
    localizedName: 'Lev bulgare',
    symbol: 'лв',
    minorUnits: 2,
    category: 'FIAT',
    status: 'PEGGED',
    monetaryAuthority: 'Bulgarian National Bank',
    countries: ['Bulgaria'],
    flagEmoji: '🇧🇬',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    pegInfo: {
      peggedToCurrency: 'EUR',
      fixedRate: 1.95583,
      monetaryTreaty: 'Bulgarian Currency Board / ERM II',
      effectiveSince: '1999-01-01',
    },
    aliases: ['lev', 'bgn'],
  },
  {
    code: 'ISK',
    numericCode: '352',
    name: 'Icelandic Krona',
    localizedName: 'Couronne islandaise',
    symbol: 'kr',
    minorUnits: 0,
    category: 'FIAT',
    status: 'ACTIVE',
    monetaryAuthority: 'Central Bank of Iceland',
    countries: ['Iceland'],
    flagEmoji: '🇮🇸',
    isMajor: false,
    isPopular: false,
    region: 'Europe',
    aliases: ['krona', 'icelandic krona', 'isk'],
  },

  // -------------------------------------------------------------
  // SPECIAL MONETARY UNITS & PRECIOUS METALS (EXPLICITLY CLASSIFIED)
  // -------------------------------------------------------------
  {
    code: 'XDR',
    numericCode: '960',
    name: 'Special Drawing Rights (SDR)',
    localizedName: 'Droits de tirage spéciaux (DTS)',
    symbol: 'SDR',
    minorUnits: 4,
    category: 'SPECIAL_MONETARY',
    status: 'ACTIVE',
    monetaryAuthority: 'International Monetary Fund (IMF)',
    countries: ['Global / IMF Member States'],
    flagEmoji: '🌐',
    isMajor: false,
    isPopular: false,
    region: 'Global / Supranational',
    aliases: ['sdr', 'dts', 'special drawing rights', 'xdr'],
  },
  {
    code: 'XAU',
    numericCode: '959',
    name: 'Gold (Troy Ounce)',
    localizedName: 'Or (Once troy)',
    symbol: 'oz t',
    minorUnits: 4,
    category: 'PRECIOUS_METAL',
    status: 'ACTIVE',
    monetaryAuthority: 'London Bullion Market Association (LBMA)',
    countries: ['Global Commodity'],
    flagEmoji: '🪙',
    isMajor: false,
    isPopular: true,
    region: 'Global / Supranational',
    aliases: ['gold', 'gold ounce', 'xau'],
  },
  {
    code: 'XAG',
    numericCode: '961',
    name: 'Silver (Troy Ounce)',
    localizedName: 'Argent (Once troy)',
    symbol: 'oz t',
    minorUnits: 4,
    category: 'PRECIOUS_METAL',
    status: 'ACTIVE',
    monetaryAuthority: 'London Bullion Market Association (LBMA)',
    countries: ['Global Commodity'],
    flagEmoji: '🥈',
    isMajor: false,
    isPopular: false,
    region: 'Global / Supranational',
    aliases: ['silver', 'silver ounce', 'xag'],
  },
];

// Helper maps for O(1) lookup
export const CURRENCIES_BY_CODE = new Map<string, CurrencyMetadata>(
  GLOBAL_CURRENCIES_LIST.map((c) => [c.code, c])
);

// Standard institutional wholesale reference baseline rates (1 USD = X Currency)
export const INSTITUTIONAL_BASELINE_RATES: Record<string, number> = {
  USD: 1.0,
  EUR: 0.92345,
  GBP: 0.79124,
  JPY: 149.824,
  CAD: 1.3542,
  CHF: 0.88452,
  AUD: 1.5218,
  NZD: 1.6385,
  CNY: 7.2345,
  INR: 83.154,
  SGD: 1.3412,
  HKD: 7.8185,
  SEK: 10.428,
  NOK: 10.584,
  DKK: 6.8912,
  AED: 3.6725,
  SAR: 3.7500,
  QAR: 3.6400,
  KWD: 0.3078,
  BHD: 0.3760,
  OMR: 0.3845,
  ILS: 3.6842,
  BRL: 5.0425,
  MXN: 17.124,
  ARS: 875.50,
  CLP: 965.20,
  COP: 3912.4,
  PEN: 3.7250,
  PAB: 1.0000,
  ZAR: 18.785,
  NGN: 1485.50,
  KES: 132.50,
  GHS: 14.85,
  EGP: 47.92,
  MAD: 10.05,
  XAF: 605.75,
  XOF: 605.75,
  DZD: 134.50,
  TND: 3.1250,
  UGX: 3820.0,
  TZS: 2580.0,
  RWF: 1295.0,
  MUR: 46.25,
  KRW: 1348.5,
  TWD: 31.85,
  THB: 36.42,
  IDR: 15890.0,
  MYR: 4.7450,
  PHP: 56.85,
  VND: 25120.0,
  PKR: 278.40,
  BDT: 117.50,
  LKR: 302.50,
  KZT: 450.20,
  TRY: 32.45,
  PLN: 3.9650,
  CZK: 23.35,
  HUF: 362.40,
  RON: 4.5920,
  BGN: 1.8060,
  ISK: 139.20,
  XDR: 0.7580,
  XAU: 0.000421, // 1 USD = 0.000421 oz t gold (~ $2,375/oz)
  XAG: 0.0348,   // 1 USD = 0.0348 oz t silver (~ $28.7/oz)
};
